module.exports = __webpack_public_path__ + "static/media/mbis_preview.90009365.png";